<template>
  <v-dialog v-model="visible" persistent max-width="638">
    <v-card v-if="visible" class="v-dialog--custom">
      <v-card-title class="headline pa-4">
        <span class="v-dialog--custom__title my-2">{{ $t(`${namespace}.changeStatus`) }}</span>
        <v-btn class="v-dialog--custom__close mr-2" fab flat color="gray-6" :disabled="isLoading" @click="close">
          <v-icon dark>close</v-icon>
        </v-btn>
      </v-card-title>

      <form novalidate @submit.prevent="changeCompanyStatus">
        <v-card-text class="px-4 pt-0">
          <v-radio-group
            v-model="status"
            v-validate="{ required: true }"
            :error-messages="errors.collect('status')"
            data-vv-name="status"
            required
            class="mt-0"
          >
            <v-radio value="enabled">
              <template slot="label">
                <p class="mb-2">
                  <span class="gray-8--text font-weight--semibold">{{ $t('Common.activate') }}</span><br>
                  <span class="gray-6--text">{{ $t(`${namespace}.statusEnabledMessage`) }}</span>
                </p>
              </template>
            </v-radio>

            <v-radio value="indebt">
              <template slot="label">
                <p class="mb-2">
                  <span class="gray-8--text font-weight--semibold">{{ $t('Common.indebt') }}</span><br>
                  <span class="gray-6--text">{{ $t(`${namespace}.statusIndebtMessage`) }}</span>
                </p>
              </template>
            </v-radio>

            <v-radio value="fraudSuspect">
              <template slot="label">
                <p class="mb-2">
                  <span class="gray-8--text font-weight--semibold">{{ $t('Common.fraud') }}</span><br>
                  <span class="gray-6--text">{{ $t(`${namespace}.statusFraudMessage`) }}</span>
                </p>
              </template>
            </v-radio>

            <v-radio value="offboarding">
              <template slot="label">
                <p class="mb-2">
                  <span class="gray-8--text font-weight--semibold">{{ $t('Common.disableCompany') }}</span><br>
                  <span class="gray-6--text">{{ $t(`${namespace}.statusDisabledMessage`) }}</span>
                </p>
              </template>
            </v-radio>

            <v-radio v-if="false" value="disable">
              <template slot="label">
                <p class="mb-0">
                  <span class="gray-8--text font-weight--semibold">{{ $t('Common.deleteCompany') }}</span><br>
                  <span class="gray-6--text">{{ $t(`${namespace}.statusDeleteMessage`) }}</span>
                </p>
              </template>
            </v-radio>
          </v-radio-group>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer />
          <a
            v-if="!isLoading"
            href="#"
            class="text--normal accent--text mr-4"
            color="accent"
            flat
            round
            @click.prevent="close"
          >
            {{ $t('Common.cancel') }}
          </a>
          <v-btn
            type="submit"
            :disabled="isLoading"
            :loading="isLoading"
            round
            depressed
            color="accent"
          >
            {{ $t(`${namespace}.changeStatus`) }}
          </v-btn>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'ChangeCompanyStatusDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    company: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState({
      routeId () {
        return this.$route.params.id ? Number(this.$route.params.id) : null
      }
    })
  },
  data () {
    return {
      namespace: 'Views.CompanyDetailsPage',
      status: null,
      isLoading: false
    }
  },
  methods: {
    ...mapActions({
      successAlert: 'snackbarAlert/success',
      errorAlert: 'snackbarAlert/error'
    }),

    close () {
      this.$emit('close')
    },

    resetAllFields () {
      this.status = null
    },

    async changeCompanyStatus () {
      this.isLoading = true

      try {
        const isValid = await this.$validator.validateAll()

        if (isValid) {
          const companyId = this.company && this.company.id
            ? this.company.id
            : this.routeId

          await this.$apiService.editCompanyStatus(companyId, this.status)
          this.resetAllFields()
          this.$emit('close', true)
          this.successAlert(this.$t(`${this.namespace}.changeStatusSuccess`))
        }
      } catch (err) {
        console.log('Error', err)
        this.errorAlert(this.$t(`${this.namespace}.changeStatusError`))
      }

      this.isLoading = false
    }
  },
  watch: {
    visible (val) {
      this.$validator._paused = !val
      this.resetAllFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.v-dialog--custom .v-radio.theme--light {
  align-items: flex-start;
}
</style>
